<template lang="pug">
Page.promo-edit
    .promo-edit__top(
        slot="header"
    )
        h1.promo-edit__title
            | Создание акции

        SvMenu(
            @remove="remove"
            @copy="copy"
        )

    SvTabs.promo-edit__table(
        :tabs="['Основное']"
        :current="0"
    )
        .promo-edit__actions
            SvButton.promo-edit__action(
                view="secondary"
                text="Отмена"
                :prependIcon=`{
                    icon: 'cancel',
                    width: 24,
                    height: 24,
                    hover: '#1993EB',
                    default: '#B7BAC6'
                }`
                @click="resetForm"
            )

            SvButton.promo-edit__action(
                view="secondary"
                text="Применить"
                :prependIcon=`{
                    icon: 'refresh',
                    width: 24,
                    height: 24,
                    hover: '#1993EB',
                    default: '#B7BAC6'
                }`
                @click="save(false)"
            )

            SvButton.promo-edit__action(
                view="primary"
                text="Сохранить"
                :prependIcon=`{
                    icon: 'check',
                    width: 24,
                    height: 24,
                    default: '#1993EB',
                    hover: '#1993EB'
                }`
                @click="save(true)"
            )

    .promo-edit__form
        .promo-edit__form-item
            span.promo-edit__form-title
                | Активность

            .promo-edit__form-elements--small.radio
                SvRadio.promo-edit__form-radio(
                    v-model="is_active"
                    :value="true"
                    label="Да"
                )

                SvRadio.promo-edit__form-radio(
                    v-model="is_active"
                    :value="false"
                    label="Нет"
                )



        .promo-edit__form-item
            span.promo-edit__form-title
                | Тип акции

            .promo-edit__form-elements--small
                SvSelect(
                  v-model="type_id"
                  :items="types"
                  view="white"
                )

        .promo-edit__form-item
            span.promo-edit__form-title
                | Название

            .promo-edit__form-elements--small
                SvInput(
                    v-model="name"
                    placeholder="название акции"
                    color="graylight"
                    :withIcon="false"
                )


        .promo-edit__form-item
            span.promo-edit__form-title
                | Жилой комплекс

            .promo-edit__form-elements--small
                SvSelect(
                  v-model="residential_complex_id"
                  :items="residentials"
                  view="white"
                )

        .promo-edit__form-item
            span.promo-edit__form-title
                | Заголовок

            .promo-edit__form-elements--medium
                SvInput(
                    v-model="title"
                    placeholder="Например: Скидки до 80 000 рублей!"
                    color="graylight"
                    :withIcon="false"
                )

        .promo-edit__form-item
            span.promo-edit__form-title
                | Описание

            .promo-edit__form-elements--medium
                SvInput(
                    v-model="subtitle"
                    placeholder="Например: Торопитесь осталось 20 квартир!"
                    color="graylight"
                    :withIcon="false"
                )

        .promo-edit__form-item
            span.promo-edit__form-title
                | Дата начала

            .promo-edit__form-elements--small
                SvDatePicker(
                    v-model="date_start"
                )

        .promo-edit__form-item
            span.promo-edit__form-title
                | Дата окончания

            .promo-edit__form-elements--small
                SvDatePicker(
                    v-model="date_end"
                )

        .promo-edit__form-item
            span.promo-edit__form-title
                | Изображение

            .promo-edit__form-elements--small
                SvUpload(
                  v-model="original_image"
                )
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import SvDatePicker from '@/components/uikit/SvDatePicker.vue';
import SvRadio from '@/components/uikit/SvRadio.vue';
import SvMenu from '@/components/uikit/SvMenu.vue';
import Page from '@/layouts/page.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvSelect from '@/components/uikit/SvSelect';
import SvTabs from '@/components/uikit/SvTabs.vue';
import SvUpload from '@/components/uikit/SvUpload.vue';


export default {
  name: 'PromoEdit',

  async beforeMount() {
    await this.$store.dispatch('residential/getList');
    await this.$store.dispatch('promo/getList');
    this.$store.dispatch('promo/getById', this.$route.params.id);
  },

  async beforeRouteUpdate(to, from, next) {
    await this.$store.dispatch('residential/getList');
    if (to.params.id !== 'new') {
      this.$store.dispatch('promo/getById', to.params.id);
    }
    next();
  },

  computed: {
    ...mapGetters({
      current: 'promo/getCurrent',
      types: 'promo/getTypes',
      residentials: 'residential/getItems'
    }),

    is_active: {
      get() { return this.current.is_active; },
      set(is_active) { this.setValue({ is_active }); },
    },

    title: {
      get() { return this.current.title; },
      set(title) { this.setValue({ title }); },
    },

    subtitle: {
      get() { return this.current.subtitle; },
      set(subtitle) { this.setValue({ subtitle }); },
    },

    name: {
      get() { return this.current.name; },
      set(name) { this.setValue({ name }); },
    },

    date_start: {
      get() { return this.current.date_start; },
      set(date_start) { this.setValue({ date_start }); },
    },

    date_end: {
      get() { return this.current.date_end; },
      set(date_end) { this.setValue({ date_end }); },
    },

    residential_complex_id: {
      get() { return this.current.residential_complex_id; },
      set(residential_complex_id) { this.setValue({ residential_complex_id }); },
    },


    type_id: {
      get() { return this.current.type; },
      set(type) { this.setValue({ type }); },
    },

    original_image: {
      get() { return this.current.original_image; },
      set(original_image) { this.setValue({ original_image }); },
    },
  },

  methods: {
    ...mapMutations({
      setValue: 'promo/setValue',
      clearCurrent: 'promo/clearCurrent',
    }),

    resetForm() {
      this.clearCurrent();
      this.$router.push({ name: 'promo' });
    },

    copy() {
      this.$store.commit('promo/setCurrent', this.$route.params.id);
      this.setValue({ id: null });
      this.$router.push({
        name: 'promo-edit',
        params: {
          id: 'new',
        },
      });
    },

    async remove() {
      await this.$store.dispatch('promo/remove', this.$route.params.id);
      this.$router.push({ name: 'promo' });
    },

    async save(isRedirect = false) {
      console.log("types", this.current);
      const id = await this.$store.dispatch('promo/save');
      if (!isRedirect) {
        this.$router.push({
          name: 'promo-edit',
          params: {
            id,
          },
        }).catch(err => {});
      } else {
        this.$router.push({ name: 'promo' });
      }
    },
  },

  components: {
    Page,
    SvInput,
    SvButton,
    SvTabs,
    SvMenu,
    SvRadio,
    SvDatePicker,
    SvUpload,
    SvSelect,
  },
};
</script>

<style lang="scss" scoped>
.promo-edit__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.promo-edit__form-title {
    display: flex;
    justify-content: flex-end;
    margin-right: 49px;
    align-items: center;
}

.promo-edit__form-item {
    display: grid;
    grid-template-columns: 291px 1fr;
    margin-top: 26px;
}

.promo-edit__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.promo-edit__form-elements--small {
    width: 311px;

    &.radio {
        display: flex;
    }
}

.promo-edit__form {
    padding: 50px 0;
}

.promo-edit__form-radio {
    margin-right: 21px;
}

.promo-edit__form-elements--medium {
    width: 495px;
}

.promo-edit__actions {
    display: flex;
    align-items: center;
    height: 100%;
}

.promo-edit__search {
    width: 47%;
    min-width: 280px;
}
</style>
